import React from "react";

// ISO alpha-2 → { name, flag } (Turkish labels)
export const COUNTRY_META = {
  TR: { name: "Türkiye", flag: "🇹🇷" },
  DE: { name: "Almanya", flag: "🇩🇪" },
  FR: { name: "Fransa", flag: "🇫🇷" },
  NL: { name: "Hollanda", flag: "🇳🇱" },
  US: { name: "Amerika", flag: "🇺🇸" },
  RU: { name: "Rusya", flag: "🇷🇺" },
  IR: { name: "İran", flag: "🇮🇷" },
  AZ: { name: "Azerbaycan", flag: "🇦🇿" },
  GR: { name: "Yunanistan", flag: "🇬🇷" },
  IQ: { name: "Irak", flag: "🇮🇶" },
  SY: { name: "Suriye", flag: "🇸🇾" },
  PS: { name: "Filistin", flag: "🇵🇸" },
  IL: { name: "İsrail", flag: "🇮🇱" },
  BE: { name: "Belçika", flag: "🇧🇪" },
  DK: { name: "Danimarka", flag: "🇩🇰" },
  SE: { name: "İsveç", flag: "🇸🇪" },
  CH: { name: "İsviçre", flag: "🇨🇭" },
  XX: { name: "Bilinmiyor", flag: "🏳️" },
};

/**
 * Plate component: renders licence plate with country badge on the left
 * when a non-Turkish country is present.
 *
 * Usage: <Plate country="DE">B-AB1234</Plate>
 * Legacy: <Plate>34ABC123</Plate>  (defaults to TR when no country prop)
 */
export function Plate({ children, country, className = "" }) {
  const code = (country || "TR").toUpperCase();
  const meta = COUNTRY_META[code] || COUNTRY_META.XX;
  const isNonTR = code !== "TR" && code !== "XX";
  return (
    <span
      className={`inline-flex items-center gap-1 ${className}`}
      data-testid={`plate-${children}`}
    >
      {isNonTR && (
        <span
          title={meta.name}
          data-testid={`plate-country-${code}`}
          className="text-base leading-none select-none"
          aria-label={meta.name}
        >
          {meta.flag}
        </span>
      )}
      <span className="tr-plate" data-plate-country={code}>
        {children}
      </span>
    </span>
  );
}

export default Plate;
